import withValidationMessage from './HOCs/withValidationMessage';
// eslint-disable-next-line
import Input from './Input';

const InputWithValidationMessage = withValidationMessage()(Input);

export default InputWithValidationMessage;
